import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Command, CommandInput, CommandList, CommandGroup, CommandItem, CommandEmpty } from "@/components/ui/command";
import { api } from "@/lib/api";

export default function CommandPalette({ open, onOpenChange }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState({ projects: [], clients: [], freelancers: [], tasks: [] });
  const nav = useNavigate();

  useEffect(() => {
    if (!open) { setQ(""); return; }
  }, [open]);

  useEffect(() => {
    const t = setTimeout(async () => {
      if (!q) { setResults({ projects: [], clients: [], freelancers: [], tasks: [] }); return; }
      try {
        const r = await api.get(`/search?q=${encodeURIComponent(q)}`);
        setResults(r.data);
      } catch {}
    }, 150);
    return () => clearTimeout(t);
  }, [q]);

  const go = (path) => { onOpenChange(false); nav(path); };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="command-palette" className="p-0 max-w-xl border-white/10 bg-[#0F0F0F]">
        <Command className="bg-transparent">
          <CommandInput
            data-testid="command-palette-input"
            placeholder="Search projects, clients, freelancers, tasks…"
            value={q}
            onValueChange={setQ}
            className="text-sm"
          />
          <CommandList className="max-h-[400px]">
            <CommandEmpty>No results.</CommandEmpty>
            {results.projects.length > 0 && (
              <CommandGroup heading="Projects">
                {results.projects.map((p) => (
                  <CommandItem key={p.id} onSelect={() => go(`/projects/${p.id}`)} data-testid={`palette-project-${p.id}`}>
                    <span className="text-white/50 mr-2">▸</span>{p.name}
                    <span className="ml-auto text-[10px] text-white/40 uppercase">{p.status}</span>
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
            {results.clients.length > 0 && (
              <CommandGroup heading="Clients">
                {results.clients.map((c) => (
                  <CommandItem key={c.id} onSelect={() => go(`/clients`)}>
                    <span className="text-white/50 mr-2">●</span>{c.name}
                    <span className="ml-auto text-[10px] text-white/40">{c.company}</span>
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
            {results.freelancers.length > 0 && (
              <CommandGroup heading="Freelancers">
                {results.freelancers.map((f) => (
                  <CommandItem key={f.id} onSelect={() => go(`/freelancers`)}>
                    <span className="text-white/50 mr-2">◆</span>{f.name}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
            {results.tasks.length > 0 && (
              <CommandGroup heading="Tasks">
                {results.tasks.map((t) => (
                  <CommandItem key={t.id} onSelect={() => go(`/tasks`)}>
                    <span className="text-white/50 mr-2">☐</span>{t.title}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
          </CommandList>
        </Command>
      </DialogContent>
    </Dialog>
  );
}
